var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-result',{attrs:{"status":"error","title":_vm.$t('统一身份认证登录失败'),"sub-title":""}},[_c('div',{attrs:{"slot":"extra"},slot:"extra"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.handleBack}},[_vm._v(_vm._s(_vm.$t('返回')))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }